import { Box, IconButton, Stack, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import type { Address } from '@/types/dtos/organizations/address.dto.ts';
import { useTranslations } from '@/i18n/use-translations';
import type { TranslationKey } from '@/i18n/translation-key';

const BillingAddressDisplay = ({
  billingAddress,
  canEdit,
  onEditClick,
}: {
  billingAddress: Address | undefined;
  canEdit: boolean;
  onEditClick: () => void;
}) => {
  const t = useTranslations();

  return (
    <>
      <Typography variant="h6" sx={{ mb: 1 }}>
        {t('organization.billingAddress')}
      </Typography>
      <Box display="flex" alignItems="start" gap={2}>
        <Stack>
          {!billingAddress && (
            <Typography variant="body2" sx={{ mt: 1 }}>
              {t('organization.noBillingAddress')}
            </Typography>
          )}
          <Typography variant="body2">{billingAddress?.name}</Typography>
          <Typography variant="body2">{billingAddress?.address1}</Typography>
          <Typography variant="body2">{billingAddress?.address2}</Typography>
          <Typography variant="body2">
            {billingAddress?.postCode} {billingAddress?.city}
          </Typography>
          {billingAddress?.country && (
            <Typography variant="body2">{t(`countries.${billingAddress?.country}` as TranslationKey)}</Typography>
          )}
          {billingAddress?.vat && (
            <Typography variant="body2">
              {t('organization.vat')}: {billingAddress?.vat}
            </Typography>
          )}
        </Stack>
        {canEdit && (
          <IconButton>
            <EditIcon onClick={onEditClick} />
          </IconButton>
        )}
      </Box>
    </>
  );
};

export default BillingAddressDisplay;
